import "./base.css";
import "./main.css";
import "./hero.css";

import Navigation from "./Navigation";
import { useState, useEffect } from "react";
import CountdownV2 from "./CountdownV2";
import SponsorModal from "./SponsorModal";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [isSponsorModalOpen, setIsSponsorModalOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth <= 800);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    document.body.style.overflow = isSponsorModalOpen ? "hidden" : "";
  }, [isSponsorModalOpen]);

  return (
    <>
      <section id="hero" className="hero overlay">
        <div className="main-slider slider">
          <ul className="slides">
            <li>
              <div className="hero-img">&nbsp;</div>
            </li>
          </ul>
        </div>

        <Navigation />

        <div className="inner-hero fade-out">
          <div className="container hero-content">
            <div className="row">
              <div
                className={`col-sm-12 text-center pb-40 ${
                  isSmallScreen ? "pt-150" : ""
                }`}
              >
                <div
                  className="col-sm-6 text-center"
                  style={{
                    borderRight: !isSmallScreen ? "1px solid white" : "",
                    paddingRight: !isSmallScreen ? 5 : 10,
                  }}
                >
                  <img
                    src="https://res.cloudinary.com/astcdubai/image/upload/v1736164746/45th_Ica_white_logo_xoggsq.png"
                    alt="logo"
                    width={isSmallScreen ? 300 : "auto"}
                  />
                </div>

                <div className="col-sm-6 text-left">
                  <h1
                    className="title"
                    style={{
                      fontSize: isSmallScreen ? 20 : 36,
                      paddingLeft: 40,
                    }}
                  >
                    The Shifting Global Order: Challenges and Regional Responses
                  </h1>
                </div>
              </div>

              {/* 🏛️ Patronage section styled */}
              {/* <div
                className="col-sm-12 text-center"
                style={{ marginBottom: 18 }}
              >
                <div
                  style={{
                    display: "inline-block",
                    backgroundColor: "#e7a73b",
                    color: "white",
                    fontWeight: 600,
                    textTransform: "uppercase",
                    padding: "4px 18px",
                    borderRadius: "4px",
                    fontSize: isSmallScreen ? 14 : 16,
                    letterSpacing: "0.5px",
                  }}
                >
                  Under the Patronage of
                </div>
                <div
                  style={{
                    color: "white",
                    fontWeight: 500,
                    fontSize: isSmallScreen ? 18 : 26,
                    marginTop: 10,
                    lineHeight: 1.4,
                  }}
                >
                  His Highness Sheikh Mohammed bin Maktoum bin Juma Al Maktoum
                </div>
                <div
                  style={{
                    color: "rgba(255,255,255,0.8)",
                    fontStyle: "italic",
                    fontSize: isSmallScreen ? 14 : 18,
                    marginTop: 6,
                  }}
                >
                  Honorary Chairman of the UAE Financial Markets Association
                </div>
              </div> */}

              {/* 🔥 Countdown */}
              {/* <div
                className="col-sm-12 text-center"
                style={{ marginBottom: 18, marginTop: 24 }}
              >
                <CountdownV2 target="2025-11-13T12:00:00+04:00" />
              </div> */}

              {/* ✅ CTA Buttons */}
              {/* <div className="col-sm-12 text-center">
                <div className="cta-row">
                  <a
                    href="#tickets"
                    className="but but-primary"
                    aria-label="Register for the conference"
                  >
                    Register Now
                  </a>

                  <button
                    type="button"
                    className="but but-secondary"
                    aria-label="Learn how to become a sponsor"
                    onClick={() => setIsSponsorModalOpen(true)}
                  >
                    Become a Sponsor
                  </button>
                </div>
              </div> */}

              {/* 📢 Post-Event Notice */}
              <div
                style={{
                  backdropFilter: "blur(6px)",
                  WebkitBackdropFilter: "blur(6px)",
                  background: "rgba(255, 255, 255, 0.12)",
                  borderRadius: 16,
                  padding: "30px 20px",
                  display: "inline-block",
                }}
              >
                <div className="col-sm-12 text-center" style={{ marginTop: 0 }}>
                  {/* MAIN EMPHASIS */}
                  <div
                    style={{
                      display: "inline-block",
                      color: "#e7a73b",
                      fontWeight: 700,
                      padding: "12px 28px",
                      borderRadius: 6,
                      fontSize: isSmallScreen ? 18 : 28,
                      letterSpacing: "1px",
                      textTransform: "uppercase",
                    }}
                  >
                    e-Certificates Now Available
                  </div>

                  {/* SUBTEXT */}
                  <p
                    style={{
                      color: "rgba(255,255,255,0.9)",
                      fontSize: isSmallScreen ? 14 : 18,
                      maxWidth: 640,
                      margin: "18px auto 0 auto",
                      lineHeight: 1.5,
                    }}
                  >
                    Participants of the 48th ICA Conference & Exhibition may now
                    request their official e-Certificate.
                  </p>

                  {/* CTA BUTTON */}
                  <button
                    type="button"
                    className="but but-primary"
                    style={{
                      marginTop: 24,
                      padding: isSmallScreen ? "10px 22px" : "14px 32px",
                      fontSize: isSmallScreen ? 14 : 18,
                      borderRadius: 8,
                      border: "none",
                    }}
                    onClick={() => navigate("/ecertificate")}
                  >
                    REQUEST HERE
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ✅ Sponsor Modal */}
      <SponsorModal
        isOpen={isSponsorModalOpen}
        onClose={() => setIsSponsorModalOpen(false)}
        setSnackbar={() => {}}
      />
    </>
  );
};

export default HeroSection;
